module.exports = __webpack_public_path__ + "static/img/img_awards_1en.ff5c159.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/img_awards_1en.png
// module id = vsF8
// module chunks = 15